<template>
  <div class="elective-score-entry-table">
    <el-table :data="electiveGradeList" style="width: 100%">
      <!-- <el-table-column prop="className" label="班级" width="180">
        <template slot-scope="scope">
          {{ scope.row.gradeName + scope.row.className }}
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="studentName" label="姓名" width="120">
      </el-table-column> -->
      <!-- <el-table-column prop="studentNumber" label="学号" width="120">
      </el-table-column> -->
      <!-- <el-table-column prop="courseName" label="科目" width="150">
      </el-table-column> -->
      <el-table-column label="班级" width="150">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.studentId"
            disabled
            placeholder="请选择"
          >
            <el-option
              v-for="item in gradeStudentList"
              :key="item.id"
              :label="item.gradeName + item.className"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="姓名" width="150">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.studentId"
            disabled
            placeholder="请选择"
          >
            <el-option
              v-for="item in gradeStudentList"
              :key="item.id"
              :label="item.studentName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="科目" width="150">
        <template slot-scope="scope">
          <el-select v-model="scope.row.courseId" disabled placeholder="请选择">
            <el-option
              v-for="item in schoolCourseList"
              :key="item.id"
              :label="item.courseName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="hours" label="学时" width="100"> </el-table-column>
      <el-table-column prop="credit" label="学分" width="100">
      </el-table-column>
      <el-table-column prop="evaluationLevel" label="评定等级">
      </el-table-column>
      <el-table-column label="操作" width="120px">
        <template slot-scope="scope">
          <div class="handle-container">
            <!-- 修改 -->
            <el-button
              type="warning"
              icon="el-icon-edit"
              @click="editClick(scope.row)"
              v-hasPermi="'sc:electivegrade:update'"
              size="small"
            >修改
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: ["electiveGradeList", "schoolCourseList", "gradeStudentList"],
  data() {
    return {};
  },
  methods: {
    editClick(item) {
      this.$emit("editClick", item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./electiveScoreEntryTable.scss";
</style>